<template>
  <div class="pageFooter" :class="isShow ? 'backgroundColor' : ''">
    <div class="container">
      <p>上海市城市管理行政执法局</p>
      <p>
        联系地址：上海市黄浦区徐家汇路579号金丽大厦
        <span style="padding-left: 30px">联系电话：021-63316800 </span>
      </p>
      <p v-if="isShow">
        信访地址：上海市普陀区凯旋北路459号<span style="padding-left: 30px"
          >接待时间：周一至周四上午9：30-11：30，下午13：30-15：30，周五上午9：30-11：30</span
        >
      </p>
      <p>
        <span v-if="!isShow">联系时间：工作日10:00-17:00</span>
        <span style="padding-left: 30px">沪ICP备 15004267号-1</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.path) // 输出的是route的对象
      if (to.path === '/list' || to.path === '/detail') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
.pageFooter.backgroundColor {
  background-color: #ffffff;
}
.pageFooter {
  display: block;
  text-align: center;
  border-top: 5px solid #366196;
  padding: 25px 0;
  background-color: #ebe9ea;
  .container {
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    font-size: 14px;
  }
}
</style>
